import React, { FC } from 'react';
import { navigate } from 'gatsby';
import './ArticleTeaser.scss';
import { toBoolean } from 'utils/stringUtils/stringUtils';
import { ArticleTeaserProps } from './models';
import NiceCard from '../NiceCard';
import ButtonPosition from '../NiceCard/CardButtonPositionEnum';

const ArticleTeaser: FC<ArticleTeaserProps> = ({
  articleBannerImage,
  articleImageAlt,
  teaser,
  title,
  url,
  moreText,
  isLabelsActive,
  label,
  moreAriaLabel,
}) => {
  const topCardContent = {
    cardImage: { imageAlt: articleImageAlt, image: articleBannerImage },
  };
  const bottomCardContent = {
    title,
    titleAsLink: true,
    titleClassname: 'article-list__card--title',
    descriptionClassname: 'article-list__card--description',
    url,
    description: teaser,
    buttons: [
      {
        text: moreText,
        className: 'article-list__card--more-link',
        buttonAsLink: true,
        ariaLabel: moreAriaLabel,
        onClick: () => navigate(url),
        position: ButtonPosition.Left,
        variant: { reversed: true },
      },
    ],
  };

  return (
    <div className="article-list__card" data-testid="article teaser">
      {toBoolean(isLabelsActive) ? <div className="article-list__card--label">{label}</div> : null}
      <NiceCard {...{ topCardContent, bottomCardContent }} />
    </div>
  );
};

export default ArticleTeaser;
